import { TWPERMISSIONS } from 'dataSource/auth/types'
import jwtDecode from 'jwt-decode'

export type CustomToken = {
  permissions?: TWPERMISSIONS[]
  sub?: string
  iss?: string
  iat?: number
  exp?: number
  providerId?: string
  ehrProfileCode?: string
  sessionId?: string
}
import { CustomAccessToken } from './types'

export const getPermissionFromToken = (token: string): TWPERMISSIONS[] => {
  try {
    const userObject: CustomAccessToken = jwtDecode(token)
    return userObject.permissions
  } catch (err) {
    return []
  }
}
